import { defineStore } from 'pinia'
import { selflinfo, userHome, getDefaultAddress } from "@/api/index";

export const useStore = defineStore('userInfo', {
  state: () => {
    return {
      userInfo: {},
      shippingAddress: {},
      orderInfo: {},
      token: ''
    }
  },
  getters: {},
  actions: {
    async updataUserInfo() {
      try {
        const res = await selflinfo()
        const res1 = await userHome()
        this.userInfo = { ...res, ...res1 }
        return Promise.resolve(res)
      } catch (res) {
        return Promise.reject()
      }
    },
    async getDefaultAddressFn() {
      try {
        const res = await getDefaultAddress()
        this.shippingAddress = res
      } catch (res) {
      }
    },
    clearStore() {
      this.userInfo = {}
      this.shippingAddress = {}
      this.orderInfo = {}
      this.token = ''
    }
  },
  persist: true
})
